import {
  type EventPayloadInput,
  type EventPayloadType,
} from "@package/ui-gql/index-analytics";
import { useSelectorWall } from "@package/ui-redux";
import { type PropsWithChildren, useCallback } from "react";
import { useWallProvider } from "../context-wall/context-wall";
import { WallAnalyticsContext } from "./context-analytics";

export function WallAnalyticsProvider({ children }: PropsWithChildren) {
  const provider = useWallProvider();
  const location = useSelectorWall((state) => state.wall.location);
  const profile = useSelectorWall((state) => state.wall.profile);
  const device = useSelectorWall((state) => state.wall.deviceId);

  const trigger = useCallback(
    <T extends EventPayloadType>(
      type: T,
      payload: EventPayloadInput[T],
      post?: string,
      layout?: string,
    ) => {
      provider?.onAnalyticsEvent({
        type,
        device,
        layout,
        location,
        payloadOneOf: {
          [type]: payload,
        },
        post,
        profile,
      });
    },
    [device, location, profile, provider],
  );

  return (
    <WallAnalyticsContext.Provider
      value={{
        trigger,
      }}
    >
      {children}
    </WallAnalyticsContext.Provider>
  );
}
